export default __webpack_public_path__ + "static/media/21.ad191445.png";